import React from 'react';
import '../template-file-css/document-file-template.css';



export const LSS_IntegratedBehavioralHealth = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_IntegratedBehavioralHealth' className='file-pdf-document'>
            <div className='file-template'>
            <h3>MH SERVICE AND SERVICE FREQUENCY</h3>
                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Service and Staff Providing Service  </span></td>
                        <td className='w-250'><span className='eleHeader'>Service Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbServiceStaffService_1" name="cbServiceStaffService_1" className='add-only' value="DiagnosticEvaluation" /> <strong>Diagnostic Evaluation</strong>
                            <span className='small'>(Includes Diagnostic Evaluation with and without medical, and Diagnostic Update) <br />Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually1_1" name="rbAnnuallyClinically1_1" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically1_1" name="rbAnnuallyClinically1_1" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbServiceStaffService_2" name="cbServiceStaffService_2" className='add-only' value="PsychoeducationSupportServices_1" /> <strong>Psychoeducation Support Services</strong>
                            <span className='small'>(Includes Psychosocial Service Rehabilitation, Therapeutic Behavioral Services) QBHS/QMHS, Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually1_2" name="rbAnnuallyClinically1_2" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically1_2" name="rbAnnuallyClinically1_2" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbServiceStaffService_3" name="cbServiceStaffService_3" className='add-only' value="PsychoeducationSupportServices_2" /> <strong>Psychoeducation Support Services Group</strong>
                            <span className='small'>(Therapeutic Behavioral Services only) <br /> QBHS/QMHS, Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually_31" name="rbAnnuallyClinically1_3" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically1_3" name="rbAnnuallyClinically1_3" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbServiceStaffService_4" name="cbServiceStaffService_4" className='add-only' value="Psychotherapy" /> <strong>Psychotherapy</strong>
                            <span className='small'> (Includes Psychotherapy for individuals, families, interactive complexity, and crisis) <br />Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually1_4" name="rbAnnuallyClinically1_4" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically1_4" name="rbAnnuallyClinically1_4" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbServiceStaffService_5" name="cbServiceStaffService_5" className='add-only' value="PsychotherapyGroup" /> <strong>Psychotherapy Group</strong>
                            <span className='small'> (Includes Psychotherapy for individuals, families, interactive complexity, and crisis) <br />Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'>
                            <span>Determined by medical provider</span>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbServiceStaffService_6" name="cbServiceStaffService_6" className='add-only' value="MedicationManagement" /> <strong>Medication Management</strong>
                            <span className='small'> Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'>
                            <span>Determined by medical provider</span>
                        </td>
                    </tr>
                </table>
                <h3>STRENGTHS, NEEDS, ABILITIES, PREFERENCES (SNAP)</h3>
                <p>
                    <span className='eleHeader'>Client Strengths</span>
                    <span className='small'>What are some things that will help you in treatment?)</span>
                    <textarea id="txtClientStrengths_1" name="txtClientStrengths_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client Strengths:</span>
                    <textarea id="txtClientStrengths_2" name="txtClientStrengths_2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client Strengths:</span>
                    <textarea id="txtClientStrengths_3" name="txtClientStrengths_3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client Needs</span>
                    <span className='small'>(What do you want to learn in treatment?)</span>
                    <textarea id="txtClientNeeds" name="txtClientNeeds" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client Abilities</span>
                    <span className='small'>(What are some of your personal qualities, skills, or talents that will help you in treatment?)</span>
                    <textarea id="txtClientAbilities" name="txtClientAbilities" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client Preferences</span>
                    <span className='small'>(What do you hope to get out of treatment?)</span>
                    <textarea id="txtClientPreferences" name="txtClientPreferences" className='add-only'></textarea>
                </p>
                <h3>PROBLEM/GOALS/METHODS AND TARGET OUTCOME RATING</h3>
                <p>
                    <span className='small'>(Either increase, decrease or extinguish frequency, intensity, duration)</span>
                </p>
                <p>
                    <span className='eleHeader'>Problem Addressed:</span>
                    <textarea id="txtProblemAddressed" name="txtProblemAddressed" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Problem Statement:</span>
                    <textarea id="txtProblemStatement" name="txtProblemStatement" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Comments</span>
                    <span className='small'>(describe problem in specific detail):</span>
                    <textarea id="txtComments" name="txtComments" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Goal Statement:</span>
                    <textarea id="txtGoalStatement" name="txtGoalStatement" className='add-only'></textarea>
                </p>
                <h3>Problem Severity:</h3>
                <p>
                    <span> <strong>(Mild 2-3; Moderate 4-6; Serious 7-8; Severe 9-10)</strong> </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Current severity of problem:</span></td>
                        <td className='w-375'> <span className='eleHeader'>Target outcome rating:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="text" id="txtCurrentSeverity" name="txtCurrentSeverity" className='add-only' /></td>
                        <td className='w-375'><input type="text" id="txtTargetOutcome" name="txtTargetOutcome" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Goal in client's Own Words:</span>
                    <textarea id="txtGoalClients" name="txtGoalClients" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date Identified:</span></td>
                        <td className='w-375'> <span className='eleHeader'>Target Completion Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="date" id="dtDateIdentified" name="dtDateIdentified" className='add-only' /></td>
                        <td className='w-375'><input type="date" id="dtTargetDate" name="dtTargetDate" className='add-only' /></td>
                    </tr>
                </table>
                <h3>All Methods/Interventions provided with the assistance of LSS eligible providers</h3>
                <p>
                    <span className='eleHeader'>Method 1 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod1_1" name="txtMethod1_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 2 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod1_2" name="txtMethod1_2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 3 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod1_3" name="txtMethod1_3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 4 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod1_4" name="txtMethod1_4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 5 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod1_5" name="txtMethod1_5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Additional Information: </span>
                    <textarea id="txtAdditionalInformation_1" name="txtAdditionalInformation_1" className='add-only'></textarea>
                </p>
                <h3>SUD SERVICE AND SERVICE FREQUENCY</h3>
                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Service and Staff Providing Service  </span></td>
                        <td className='w-250'><span className='eleHeader'>Service Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_1" name="cbStaffProvidingService_1" className='add-only' value="SudAssessment" /> <strong>SUD Assessment and ASAM Level of Care</strong>
                            <span className='small'>Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_1" name="rbAnnuallyClinically2_1" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_1" name="rbAnnuallyClinically2_1" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_2" name="cbStaffProvidingService_2" className='add-only' value="SudCaseManagement" /> <strong>SUD Case Management</strong>
                            <span className='small'>QBHS, Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_2" name="rbAnnuallyClinically2_2" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_2" name="rbAnnuallyClinically2_2" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_3" name="cbStaffProvidingService_3" className='add-only' value="SudPsychotherapy" /> <strong>SUD Psychotherapy (Individual, Family)</strong>
                            <span className='small'>Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_3" name="rbAnnuallyClinically2_3" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_3" name="rbAnnuallyClinically2_3" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_4" name="cbStaffProvidingService_4" className='add-only' value="SudPsychotherapyGroup" /> <strong>SUD Psychotherapy Group</strong>
                            <span className='small'> Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_4" name="rbAnnuallyClinically2_4" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_4" name="rbAnnuallyClinically2_4" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_5" name="cbStaffProvidingService_5" className='add-only' value="SudIndividualCounseling" /> <strong>SUD Individual Counseling</strong>
                            <span className='small'> CDCA professionals only</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_5" name="rbAnnuallyClinically2_5" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_5" name="rbAnnuallyClinically2_5" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_6" name="cbStaffProvidingService_6" className='add-only' value="IntensiveOutpatient" /> <strong>Intensive Outpatient</strong>
                            <span className='small'> Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_6" name="rbAnnuallyClinically2_6" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_6" name="rbAnnuallyClinically2_6" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_7" name="cbStaffProvidingService_7" className='add-only' value="PeerSupporter" /> <strong>PEER Supporter</strong>
                            <span className='small'> Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_7" name="rbAnnuallyClinically2_7" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_7" name="rbAnnuallyClinically2_7" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_8" name="cbStaffProvidingService_8" className='add-only' value="StepDown" /> <strong>Step-Down After Care  </strong>
                        </td>
                        <td className='w-250'><input type="radio" id="rbAnnually2_8" name="rbAnnuallyClinically2_8" className='add-only' value="Annually" /> Annually &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbClinically2_8" name="rbAnnuallyClinically2_8" className='add-only' value=" Clinically" /> Clinically</td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbStaffProvidingService_9" name="cbStaffProvidingService_9" className='add-only' value="LaboratoryAnalysis" /> <strong>Laboratory Analysis</strong>
                            <span className='small'> Licensed professionals as identified in OAC 5122-29-03</span>
                        </td>
                        <td className='w-250'>
                            <span>To be determined by medical provider</span>
                        </td>
                    </tr>
                </table>
                <h3>ASAM Level of Care</h3>
                <p> <span className='small'>(as identified from SUD Assessment) </span></p>
                <table>
                    <tr>
                        <td className='w-180'>
                            <input type="checkbox" id="cbAsamLevelCare_1" name="cbAsamLevelCare_1" className='add-only' value="AsamLevelCare_1" />Level 1 Outpatient &nbsp;&nbsp;

                        </td>
                        <td className='w-180'>
                            <input type="checkbox" id="cbAsamLevelCare_2" name="cbAsamLevelCare_2" className='add-only' value="AsamLevelCare_2" />Level 2.1 Intensive Outpatient &nbsp;&nbsp;
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbAsamLevelCare_3" name="cbAsamLevelCare_3" className='add-only' value="AsamLevelCare_3" />Level 3.1 Halfway House
                        </td>
                        <td className='w-180'>
                            <input type="checkbox" id="cbAsamLevelCare_4" name="cbAsamLevelCare_4" className='add-only' value="AsamLevelCare_4" />Level 3.5 Non-medical Residential

                        </td>
                    </tr>
                </table>
                <h3>PROBLEM/GOALS/METHODS AND TARGET OUTCOME RATING </h3>
                <p> <span className='small'> (Either increase, decrease or extinguish frequency, intensity, duration)</span></p>
                <p> <span className='eleHeader'>Problem Addressed: </span>
                    <span className='small'> SUBSTANCE USE </span>
                    <textarea id="txtOUTCOME_ProblemAddressed" name="txtOUTCOME_ProblemAddressed" className='add-only'></textarea>
                </p>
                <p> <span className='eleHeader'>Problem Statement: </span>
                    <textarea id="txtOUTCOME_ProblemStatement" name="txtOUTCOME_ProblemStatement" className='add-only'></textarea>
                </p>
                <p> <span className='eleHeader'>Comments </span>
                    <span className='small'> (describe problem in specific detail): </span>
                    <textarea id="txtOUTCOME_Comments" name="txtOUTCOME_Comments" className='add-only'></textarea>
                </p>
                <p> <span className='eleHeader'>Goal Statement:</span>
                    <textarea id="txtOUTCOME_GoalStatement" name="txtOUTCOME_GoalStatement" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Current severity of problem:</span></td>
                        <td className='w-375'> <span className='eleHeader'>Target outcome rating:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="text" id="txtOUTCOME_CurrentSeverity" name="txtOUTCOME_CurrentSeverity" className='add-only' /></td>
                        <td className='w-375'><input type="text" id="txtOUTCOME_TargetOutcome" name="txtOUTCOME_TargetOutcome" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Goal in client's Own Words:</span>
                    <textarea id="txtOUTCOME_GoalClients" name="txtOUTCOME_GoalClients" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date Identified:</span></td>
                        <td className='w-375'> <span className='eleHeader'>Target Completion Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="date" id="dtOUTCOME_DateIdentified" name="dtOUTCOME_DateIdentified" className='add-only' /></td>
                        <td className='w-375'><input type="date" id="dtOUTCOME_TargetDate" name="dtOUTCOME_TargetDate" className='add-only' /></td>
                    </tr>
                </table>
                <h3>All Methods/Interventions provided with the assistance of LSS eligible providers</h3>
                <p>
                    <span className='eleHeader'>Method 1 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod2_1" name="txtMethod2_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 2 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod2_2" name="txtMethod2_2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 3 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod2_3" name="txtMethod2_3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 4 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod2_4" name="txtMethod2_4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Method 5 </span>
                    <span className='small'>(Intervention): </span>
                    <textarea id="txtMethod2_5" name="txtMethod2_5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Additional Information: </span>
                    <textarea id="txtAdditionalInformation_2" name="txtAdditionalInformation_2" className='add-only'></textarea>
                </p>
                <h3>MEDICAL NECESSITY OF SERVICES (MH and SUD)</h3>
                <p>
                    <span className='eleHeader'>Severity of Symptoms: </span>
                    <textarea id="txtSeveritySymptoms" name="txtSeveritySymptoms" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Levels of functioning impairment:  </span>
                    <textarea id="txtfunctioningimpairment" name="txtfunctioningimpairment" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Area of Functioning Impairment  </span>
                    <input type="checkbox" id="cbAreaFunctioning_1" name="cbAreaFunctioning_1" className='add-only' value="AreaFunctioning_1" />Work/occupation &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbAreaFunctioning_2" name="cbAreaFunctioning_2" className='add-only' value="AreaFunctioning_2" />School  &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbAreaFunctioning_3" name="cbAreaFunctioning_3" className='add-only' value="AreaFunctioning_3" />Family Relations &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbAreaFunctioning_4" name="cbAreaFunctioning_4" className='add-only' value="AreaFunctioning_4" />Social &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbAreaFunctioning_5" name="cbAreaFunctioning_5" className='add-only' value="AreaFunctioning_5" />Judgment &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbAreaFunctioning_6" name="cbAreaFunctioning_6" className='add-only' value="AreaFunctioning_6" />Thinking &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbAreaFunctioning_7" name="cbAreaFunctioning_7" className='add-only' value="AreaFunctioning_7" />Mood
                </p>
                <p>
                    <span className='eleHeader'>Does the DSM 5 diagnosis with a description of functioning and symptoms?  </span>
                    <input type="radio" id="rbfunctioningsymptoms_Yes" name="rbfunctioningsymptoms" className='add-only' value="Yes" /> Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio" id="rbfunctioningsymptoms_No" name="rbfunctioningsymptoms" className='add-only' value="No" /> No
                </p>
                <h3>Clinical Recommendations and Transition Pan (MH and SUD)</h3>
                <p>
                    <span className='eleHeader'>Without treatment, will the client be expected to suffer prolonged, increased or new psychiatric symptoms or impairment of functioning?</span>
                    <input type="radio" id="rbClinicalRecommendations_Yes" name="rbClinicalRecommendations" className='add-only' value="Yes" /> Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio" id="rbClinicalRecommendations_No" name="rbClinicalRecommendations" className='add-only' value="No" /> No
                </p>
                <p>
                    <span>What is the client's transition plan from mental health services?</span>
                    <span className='small'>*ITP to be reviewed annually, at client's request, as clinically indicated, or adding/ terminating of a service</span>
                    <span>What is the client's transition plan from SUD services? </span>
                    <span className='small'>*ITP to be reviewed every 90 days, at client's request, as clinically indicated, or adding/ terminating of a service</span>
                </p>
                <h3>ITP GOAL REVIEW</h3>
                <p>
                    <span className='eleHeader'>Reason for Review:</span>
                    <textarea id="txtReasonReview" name="txtReasonReview" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Progress:</span>
                    <textarea id="txtProgress" name="txtProgress" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>  <span className='eleHeader'>New Target date </span></td>
                    </tr>
                    <tr>
                        <td> <span className='small'>(if goal continued):</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type="date" id="txtTargetDate" name="txtTargetDate" className='add-only' /></td>
                        <td className='w-50'></td>
                        <td className='w-350'><input type="checkbox" id="cbPreviousGoal" name="cbPreviousGoal" className='add-only' value="PreviousGoal" /><strong>Previous goal(s) discontinued</strong></td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Remarks regarding client's progress: </span>
                    <textarea id="txtRemarksregarding" name="txtRemarksregarding" className='add-only'></textarea>
                </p>
                <h3>Signatures</h3>
                <table>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">client's Signature (sign above)</td>
                        <td className="w-280 small">Printed Name</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">Parent/Legally Authorized representative Signature</td>
                        <td className="w-280 small">Printed Name</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">Other (Specify)</td>
                        <td className="w-280 small">Printed Name</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">Staff/Credentials</td>
                        <td className="w-280 small">Printed Name/Credentials</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">Provider/Credentials</td>
                        <td className="w-280 small">Printed Name/Credentials</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">Supervisor/Credentials (if applicable)</td>
                        <td className="w-280 small">Printed Name/Credentials</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-320 small">Physician Signature/Credentials (if applicable) </td>
                        <td className="w-280 small">Printed Name/Credentials</td>
                        <td className="w-150 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-320 signature' >&nbsp;</td>
                        <td className='w-280 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}
                
